import { PayloadAction } from '@reduxjs/toolkit';
import { deleteSocio } from '../../api/miembros/miembroSocio';
import { GenericState } from '../../types/apiModule';
import { Socio } from '../../types/socio/socio';
import createApiModule from '../createApiModule';
import { showSnackBar } from '../snackBar/snackBarSlice';
import { getMiembroSocio } from './getMiembroSocioModule';
import { t } from '../../i18n';

export interface deleteMiembroSocioState extends GenericState<unknown> {
  active: boolean;
  data: Socio | null;
}
const initialState: deleteMiembroSocioState = {
  errors: null,
  loading: false,
  active: false,
  data: null,
};

const deleteMiembroSocioModule = createApiModule({
  name: 'deleteMiembroSocio',
  initialState,
  apiMethod: deleteSocio,
  onSuccess: () => [
    showSnackBar({
      severity: 'success',
      message: t('MESSAGE_SUSCRIPCION_CANCELADA'),
    }),
    getMiembroSocio({}),
  ],
  onError: () => ({
    message: t(
      'StoreMiembrosDeleteMiembroSocioModuleSeHaProducidoUnErrorAlCancelarTuSuscripcion',
    ),
  }),
  onValidationError: () => ({
    message: t(
      'StoreMiembrosDeleteMiembroSocioModuleSeHaProducidoUnErrorAlCancelarTuSuscripcion',
    ),
  }),
  reducers: {
    show(state, action: PayloadAction<Socio>) {
      state.active = true;
      state.data = action.payload;
    },
    hide(state) {
      state.active = false;
    },
  },
});

export const {
  start: deleteMiembroSocio,
  success: deleteMiembroSocioOk,
  error: deleteMiembroSocioKo,
  hide: hideDeleteMiembroSocio,
  show: showDeleteMiembroSocio,
} = deleteMiembroSocioModule.slice.actions;

export default deleteMiembroSocioModule;
